export interface IDataModelDictionary {
    [index : string] : DataModelElement;
}

export class DataModelElement {
    
    array : boolean = false;
    defaultValue : string;
    dataType : string;
    min : number;
    max : number;
    namePattern : string;
    notEmpty : boolean = false;
    prerequisite : string;
    referenceElement : string;
    setBeforeGet : boolean = false;
    skipOnCommit : boolean = false;
    readOnly : boolean = false;
    uniqueInArray : boolean = false;
    validValues : string[];
    writeOnce : boolean = false;
    writeOnly : boolean = false;

}